import classNames from "classnames";
import {IAttrs} from "@ok/utils/types/IAttrs";
import classes from "../Icon.styl";

/**
 * @see odkl.mobile.ui.components.base.images.icon.TextIconBuilder.Size
 */
export const IconSizes = {
    "8": "8",
    "12": "12",
    "16": "16",
    "18": "18",
    "20": "20",
    "24": "24",
    "26": "26",
    "28": "28",
    "32": "32",
    "48": "48",
};

export const CustomIconSize = {
    "40": classes["size-40"],
    "64": classes["size-64"],
    "96": classes["size-96"],
    "112": classes["size-112"],
};

export type IIconSize = keyof typeof IconSizes | keyof typeof CustomIconSize;
export type ICustomIconSize = keyof typeof CustomIconSize;

export interface IIconParams {
    /**
     * Размер иконки
     */
    size?: IIconSize;

    /**
     * Добавить отступ справа 4px
     */
    marginRight?: boolean;

    /**
     * Добавить отступ слева 4px
     */
    marginLeft?: boolean;

    /**
     * Доп класс
     */
    className?: string;

    /**
     * Доп класс
     */
    attrs?: IAttrs;
}

export function createRootClassName({marginRight, marginLeft, className}: IIconParams) {
    return classNames(
        "js-lazy-icon",
        classes["icon"],
        {
            [classes["__margin-right"]]: marginRight,
            [classes["__margin-left"]]: marginLeft
        },
        className
    );
}

export const sizeCssClass = (size: IIconSize) => {
    const castedSize = size as unknown as ICustomIconSize;
    if (CustomIconSize[castedSize]) {
        return CustomIconSize[castedSize];
    } else {
        return `ic${size}`;
    }
};
